export default "__VITE_ASSET__t5B7r8AJ__"